import { render, staticRenderFns } from "./editJump.vue?vue&type=template&id=530af7dc&scoped=true"
import script from "./editJump.vue?vue&type=script&lang=js"
export * from "./editJump.vue?vue&type=script&lang=js"
import style0 from "./editJump.vue?vue&type=style&index=0&id=530af7dc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530af7dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('530af7dc')) {
      api.createRecord('530af7dc', component.options)
    } else {
      api.reload('530af7dc', component.options)
    }
    module.hot.accept("./editJump.vue?vue&type=template&id=530af7dc&scoped=true", function () {
      api.rerender('530af7dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/applet/setting/jumpNav/editJump.vue"
export default component.exports